const SUPPORTED_PROVIDER_MODES = new Set(["paystack", "paystack_test", "worldline"]);

/**
 * The browser must follow the same deliberate provider contract as the Edge
 * functions.  Retired providers are intentionally not represented here: an
 * unset or unknown mode is unavailable, never a fallback.
 */
export function activePaymentProviderMode(value = import.meta.env.VITE_PAYMENT_PROVIDER) {
  const mode = String(value || "").trim().toLowerCase();
  return SUPPORTED_PROVIDER_MODES.has(mode) ? mode : "unsupported";
}

export function isPaystackRuntime(value) {
  const mode = activePaymentProviderMode(value);
  return mode === "paystack" || mode === "paystack_test";
}

export function isPaystackTestRuntime(value) {
  return activePaymentProviderMode(value) === "paystack_test";
}

// This is presentation-only. The Edge Function independently rejects every
// Test-helper action unless it is explicitly enabled in Paystack TEST mode.
// A Production bundle therefore cannot revive the helper merely by changing
// browser state or hiding it with CSS.
export function isPaystackTestHelperRuntime({
  provider = import.meta.env.VITE_PAYMENT_PROVIDER,
  enabled = import.meta.env.VITE_AFRIMED_PAYSTACK_TEST_HELPER_ENABLED,
  development = import.meta.env.DEV,
} = {}) {
  return isPaystackTestRuntime(provider) && (
    development === true || String(enabled || "").trim().toLowerCase() === "true"
  );
}

export function isWorldlineRuntime(value) {
  return activePaymentProviderMode(value) === "worldline";
}

export function paymentProviderUnavailableMessage() {
  return "Secure payment is unavailable because no supported payment provider is configured.";
}
